(() => {
  class OverflowSlider extends HTMLElement {
    selectors = {
      slider: '.overflow-slider__slider',
      sliderNavPagination: '.overflow-slider__slider-nav-pagination',
      sliderNavButtonNext: '.overflow-slider__slider-nav-button-next',
      sliderNavButtonPrev: '.overflow-slider__slider-nav-button-prev'
    };

    elements = {
      slider: this.querySelector(this.selectors.slider),
      sliderNavPagination: this.querySelector(this.selectors.sliderNavPagination),
      sliderNavButtonNext: this.querySelector(this.selectors.sliderNavButtonNext),
      sliderNavButtonPrev: this.querySelector(this.selectors.sliderNavButtonPrev)
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    };

    disconnectedCallback() {
      this.destroy();
    };

    init = () => {
      this.initSlider();
    }

    destroy = () => {
      this.destroySlider();
    }

    initSlider = () => {
      $(this.selectors.slider).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        variableWidth: true,
        arrows: true,
        infinite: true,
        prevArrow: this.elements.sliderNavButtonPrev,
        nextArrow: this.elements.sliderNavButtonNext,
        appendDots: this.elements.sliderNavPagination,
        responsive: [
          {
            breakpoint: 641,
            settings: {
              variableWidth: false,
              slidesToShow: 1.11,
              infinite: false,
            }
          }
        ]
      });

      window.addEventListener('resize', () => {
        $(this.selectors.slider).slick('resize');
      });
    }

    destroySlider = () => {
      $(this.selectors.slider).slick('destroy');
    }
  }

  if (!customElements.get('overflow-slider')) {
    customElements.define('overflow-slider', OverflowSlider);
  }
})();
